// subs.ts — Step 4. Subs roster (COI + W-9 compliance aggregate).
// See workers/core-os/src/routes/subs.ts.

import { request } from './request'

export interface SubRosterEntry {
  sub_key: string
  sub_name: string
  sub_profile_id: string | null
  coi_status: 'current' | 'expired' | 'expiring_soon' | 'none'
  coi_expiration_date: string | null
  coi_carrier: string | null
  // Patch 010.D.3 — latest non-archived COI record for the insurance-draft
  // action; null when the sub has no COI on file.
  latest_coi_record_id: string | null
  insurance_draft_exists: boolean
  w9_status: 'received' | 'requested' | 'none'
}

export interface SubsRosterResponse {
  ok: true
  subs: SubRosterEntry[]
  summary: {
    sub_count: number
    coi_expired: number
    coi_expiring_soon: number
    coi_missing: number
    w9_missing: number
  }
}

// Patch 010.D.5 — retroactive Gmail COI backfill summary.
// Patch 010.D.8 — + the force-recreate counters.
export interface CoiBackfillSummary {
  ok: true
  scanned: number
  classified_coi: number
  created: number
  skipped_dup_message: number
  skipped_dup_record: number
  skipped_coi_unfiled: number
  recreated_drafts: number
  recreate_failed: number
  drafts_missing_in_gmail: number
  drafts_missing_best_effort: boolean
  force_recreate_drafts: boolean
  errors: string[]
  request_id: string
}

export const subsApi = {
  roster: () => request<SubsRosterResponse>('/api/subs-roster'),
  // Patch 010.D.5 — the endpoint is Gmail-domain (/api/gmail/backfill-coi)
  // but its sole consumer is the Subs roster, so the client method lives
  // here with the roster it serves.
  backfillCoi: (body: {
    since_days?: number
    max_messages?: number
    force_recreate_drafts?: boolean
  }) =>
    request<CoiBackfillSummary>('/api/gmail/backfill-coi', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
}
